// removed by extract-text-webpack-plugin
module.exports = {"header":"header-080c14","header__logo":"header__logo-3a51df","header__h":"header__h-18e3ce","header__help":"header__help-ba1eb0"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/header/style.pcss
// module id = ./src/blocks/header/style.pcss
// module chunks = 0